import React from "react";
import Tab from "../common/Tab/Tab";
import TabItem from "../common/Tab/TabItem";

const ReputationTab = (props: any) => {
    return (
        <Tab tabId="identity-vault-tabs">
            <TabItem title="Overview" link="/my-reputation" tabNo="1" selectedTab={props.selectedTab} />
            <TabItem title="Data Sources" link="/my-reputation-data-sources" tabNo="2" selectedTab={props.selectedTab} />
        </Tab>
    );
};
export default ReputationTab;
